import React, { useContext, useEffect, useState } from 'react';
import FarmSelectionComponent from './FarmSelectionComponent';
import WidgetSectionTitle from '../../../widgets/CustomWidgetSectionTitle';

import useApi from 'hooks/useApi';
import {
  getBlockDetails,
  getBlockList
} from 'api/endpoints/ManagementServices';
import { getEnvironmentData } from 'api/endpoints/EnvironmentalServices';
import { getHydrologyData } from 'api/endpoints/HydrologicalServices';
import { getPedologyData } from 'api/endpoints/PedologicalServices';
import { getTerrainData } from 'api/endpoints/TerrestrialServices';

import { jwtDecode } from 'jwt-decode';
import { get } from 'lodash';
import CustomSelect from 'components/common/CustomSelect';
import { isEmpty } from 'lodash';
import ObservationRenderer from './ObservationRenderer';
import socialIcons from 'data/socialIcons';
import { Form, Row } from 'react-bootstrap';
import waterIcon from 'assets/img/icons/water.svg';
import locationIcon from 'assets/img/icons/land.svg';
import soilIcon from 'assets/img/icons/soil_param.svg';
import Enviroment from 'assets/img/icons/Enviroment.svg';

import AppContext from 'context/Context';
import { useNavigate, useParams } from 'react-router-dom';
import CardSkeleton from 'components/common/skeleton/CardSkeleton';
import { forIn } from 'lodash';
import { getTenantFromToken } from 'utils/routeUtils';

function FarmLevel() {
  const { setConfig } = useContext(AppContext);
  const { cluster } = useParams();
  const navigate = useNavigate();

  const tenant = getTenantFromToken();

  const [blockList, setBlockList] = useState([]);
  const [block, setBlock] = useState(null);
  const [blockData, setBlockData] = useState(null);
  const [blockListData, setBlockListData] = useState([]);
  const [filteredCoordinate, setFilteredCoordinate] = useState(null);

  const [terrainData, setTerrainData] = useState(null);
  const [hydrologyData, setHydrologyData] = useState(null);
  const [environmentData, setEnvironmentData] = useState(null);
  const [pedologyData, setPedologyData] = useState(null);

  const getBlockListAPI = useApi(getBlockList);
  const getBlockDetailsAPI = useApi(getBlockDetails);

  const getTerrainDataAPI = useApi(getTerrainData);
  const getHydrologyDataAPI = useApi(getHydrologyData);
  const getEnvironmentDataAPI = useApi(getEnvironmentData);
  const getPedologyDataAPI = useApi(getPedologyData);

  useEffect(() => {
    setConfig('cluster', cluster);
    // setshowErrorPage(false);

    if (cluster) {
      // resetApiStates(); // Reset loading and data for all APIs
      let tenantId = tenant;
      let blockId = cluster;
      getBlockDetailsAPI.request({ tenantId, blockId });
    }
  }, [cluster]);

  useEffect(() => {
    const blockData = get(getBlockDetailsAPI, 'data.results', []);
    setBlockData(blockData.features);
  }, [getBlockDetailsAPI.data]);

  // useEffect(() => {
  //   const blockData = getBlockListAPI.request(tenant);
  //   // setBlockListData(blockData.features);
  // }, [getBlockDetailsAPI.data]);

  const apiHooks = [
    getTerrainDataAPI,
    getHydrologyDataAPI,
    getEnvironmentDataAPI,
    getPedologyDataAPI
  ];

  const performSequentialAPICalls = async project_ids => {
    // setApisLoading(true);
    let tenant_id = tenant;
    let parent_id = cluster;
    for (let i = 0; i < apiHooks.length; i++) {
      await apiHooks[i].request({ tenant_id, parent_id, project_ids });
    }
    // setApisLoading(false);~
  };

  const handleSearch = project_ids => {
    performSequentialAPICalls(project_ids);
    let wholeCoordinage = [blockData[0].properties.id, ...project_ids];
    let CoordinateData = blockData.filter(item =>
      wholeCoordinage.includes(item.properties.id)
    );
    setFilteredCoordinate(CoordinateData);
    setTerrainData(null);
    setEnvironmentData(null);
    setPedologyData(null);
    setHydrologyData(null);
  };

  useEffect(() => {
    if (!isEmpty(getTerrainDataAPI.data)) {
      const data = get(getTerrainDataAPI.data, 'results', {});
      setTerrainData(data);
    }
  }, [getTerrainDataAPI.data]);

  useEffect(() => {
    if (!isEmpty(getHydrologyDataAPI.data)) {
      setHydrologyData(get(getHydrologyDataAPI.data, 'results', {}));
    }
  }, [getHydrologyDataAPI.data]);

  useEffect(() => {
    if (!isEmpty(getEnvironmentDataAPI.data)) {
      setEnvironmentData(get(getEnvironmentDataAPI.data, 'results', {}));
    }
  }, [getEnvironmentDataAPI.data]);

  useEffect(() => {
    if (!isEmpty(getPedologyDataAPI.data)) {
      setPedologyData(get(getPedologyDataAPI.data, 'results', {}));
    }
  }, [getPedologyDataAPI.data]);

  // useEffect(() => {
  //   if (!isEmpty(getBlockListAPI.data)) {
  //     const responseData = get(getBlockListAPI.data, 'results', {});
  //     const filterOptions = [];
  //     forIn(responseData, block => {
  //       filterOptions.push({ key: block.id, value: block.name });
  //     });
  //     if (!isEmpty(filterOptions)) {
  //       setBlockListData(filterOptions);
  //     }
  //   }
  // }, []);

  // const handleChange = ({ target }) => {
  //   setConfig('cluster', target.value);
  //   navigate(`/${tenant}/plotoverlay/${target.value}`);
  // };
  return (
    <div>
      {/* <Form.Select
        name="cluster"
        value={blockListData?.some(item => item.key === cluster) ? cluster : ''}
        onChange={handleChange}
        style={{ minWidth: '21.5rem' }}
      >
        <option key="blankChoice" hidden value>
          Select a Cluster
        </option>
        {blockListData?.map(item => (
          <option key={item.key} value={item.key}>
            {item.value}
          </option>
        ))}
      </Form.Select> */}
      {blockData && (
        <FarmSelectionComponent handleSearch={handleSearch} data={blockData} />
      )}
      {getTerrainDataAPI && getTerrainDataAPI.loading && <CardSkeleton />}
      {terrainData && filteredCoordinate.length > 0 && (
        <div>
          <WidgetSectionTitle
            icon={locationIcon}
            title="Vegetation Parameters"
            transform="shrink-4"
            className="mb-4 mt-4 align-items-center"
          />
          <Row className="g-3 mb-3">
            <ObservationRenderer
              observation={terrainData}
              coordinates={filteredCoordinate}
              loading={getTerrainDataAPI.loading}
            />
          </Row>
        </div>
      )}
      {hydrologyData && filteredCoordinate.length > 0 && (
        <div>
          <WidgetSectionTitle
            icon={waterIcon}
            title="Water Availability"
            transform="shrink-4"
            className="mb-4 mt-4 align-items-center"
          />
          <Row className="g-3 mb-3">
            <ObservationRenderer
              observation={hydrologyData}
              coordinates={filteredCoordinate}
              loading={getHydrologyDataAPI.loading}
            />
          </Row>
        </div>
      )}
      {environmentData && filteredCoordinate.length > 0 && (
        <div>
          <WidgetSectionTitle
            icon={Enviroment}
            title="Air Quality"
            transform="shrink-4"
            className="mb-4 mt-4 align-items-center"
          />
          <Row className="g-3 mb-3">
            <ObservationRenderer
              observation={environmentData}
              coordinates={filteredCoordinate}
              loading={getEnvironmentDataAPI.loading}
            />
          </Row>
        </div>
      )}
      {pedologyData && filteredCoordinate.length > 0 && (
        <div>
          <WidgetSectionTitle
            icon={soilIcon}
            title="Soil Parameters"
            transform="shrink-4"
            className="mb-4 mt-4 align-items-center"
          />
          <Row className="g-3 mb-3">
            <ObservationRenderer
              observation={pedologyData}
              coordinates={filteredCoordinate}
              loading={getPedologyDataAPI.loading}
            />
          </Row>
        </div>
      )}
    </div>
  );
}

export default FarmLevel;
